import { render } from "./TheMbImportantLinkCollection.vue?vue&type=template&id=6df512ca&scoped=true"
import script from "./TheMbImportantLinkCollection.vue?vue&type=script&lang=js"
export * from "./TheMbImportantLinkCollection.vue?vue&type=script&lang=js"

import "./TheMbImportantLinkCollection.vue?vue&type=style&index=0&id=6df512ca&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6df512ca"

export default script